export default "__VITE_ASSET__BhU2NdXx__"